// extracted by mini-css-extract-plugin
export default {"row":"createTask_row__k1wEu","col":"createTask_col__eKwA-","card":"createTask_card__Abxbf"};